module.exports = __webpack_public_path__ + "static/media/cruz.ccb50316.svg";